const VALID_STAGES = new Set([
  'dashboard',
  'leadfinder',
  'whatsapp',
  'stage1',
  'stage4',
  'stage2',
  'stage3',
  'settings',
]);

// Maps URL path slugs → internal stage keys
const PATH_TO_STAGE = {
  '': 'dashboard',
  dashboard: 'dashboard',
  'lead-finder': 'leadfinder',
  leadfinder: 'leadfinder',
  whatsapp: 'whatsapp',
  scrape: 'stage1',
  'lead-scraping': 'stage1',
  'fb-ads': 'stage4',
  review: 'stage2',
  'manual-review': 'stage2',
  dm: 'stage3',
  'dm-automation': 'stage3',
  settings: 'settings',
};

// Maps internal stage keys → clean URL slugs
const STAGE_TO_PATH = {
  dashboard: '/dashboard',
  leadfinder: '/lead-finder',
  whatsapp: '/whatsapp',
  stage1: '/scrape',
  stage4: '/fb-ads',
  stage2: '/review',
  stage3: '/dm',
  settings: '/settings',
};

function parsePath() {
  return String(window.location.pathname || '/')
    .replace(/^\//, '')
    .split('/')[0]
    .trim()
    .toLowerCase();
}

export function stageFromLocation() {
  const slug = parsePath();
  const stage = PATH_TO_STAGE[slug];
  return VALID_STAGES.has(stage) ? stage : 'dashboard';
}

export function hashForStage(stage) {
  return STAGE_TO_PATH[stage] || '/dashboard';
}

export function replaceStageHash(stage) {
  const next = STAGE_TO_PATH[stage] || '/dashboard';
  if (window.location.pathname !== next) {
    window.history.replaceState(null, '', next);
  }
}

export function pushStageHash(stage) {
  const next = STAGE_TO_PATH[stage] || '/dashboard';
  if (window.location.pathname !== next) {
    window.history.pushState(null, '', next);
  }
}

